import React, {Component, useState} from 'react';
import {Button, Col, Image, Row, Tab} from "react-bootstrap";

import './style.css';

class AnimationsPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeAnimation: null,
            activeTab: 'page'
        }
    }

    componentDidMount() {
        if (!this.isElementSelected()) {
            this.setState({
                activeTab: 'page'
            })
        }
    }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (this.state.animationDuration !== prevState.animationDuration) {
    //         this.applyAnimation(this.state.activeAnimation);
    //     }
    // }

    isValidInput = (inp, min, max) => {
        if (inp === "") return true;
        let val = parseFloat(inp);
        return (!isNaN(val) && val >= min && val <= max);
    };

    applyElementAnimation = (animation) => {
        if(!this.props.design_selection){
            return false;
        }

        if (this.props.design_selection.get_parent('grid')) {
            this.props.design_selection.get_parent('grid').animation = (animation.displayName !== 'None' ? animation.displayName : null);

            this.props.design_selection.get_parent("page").animate();
        } else {
            this.props.design_selection.animation = (animation.displayName !== 'None' ? animation.displayName : null);

            if(this.props.design_selection && this.props.design_selection.get_parent("page")){
                this.props.design_selection.get_parent("page").animate()
            }
        }
    };


    setAnimationDuration = (duration) => {
        if(window.design_editor.active_page){
            window.design_editor.active_page.animation_duration = duration;
        }
    };

    applyPageAnimation = (animation, page) => {
        page.animation = animation.displayName;
        page.animate();
    };

    applyAnimation = (animation) => {
        this.setState({
            activeAnimation : animation.displayName
        });
        this.state.activeTab === 'page' ? this.applyPageAnimation(animation, window.design_editor.active_page): this.applyElementAnimation(animation);
        window.design_editor.addUndoChange();
    };

    animationCard = ({isActive, idxx, animation_name}) => {
        const [ is_hovering, set_is_hovering ] = useState(false);
        let mouse_out_func = idxx => {
            document.getElementById('video-card'+idxx).pause();
            document.getElementById('video-card'+idxx).currentTime=0; 
        };
        return (
            <div className={isActive ? 'glowing-border' : 'filter-div'} style={{height: 80, width: 80, backgroundColor: 'white'}} onMouseOver={() => set_is_hovering(true)} onMouseOut={() => set_is_hovering(false)}>
                {
                    (!is_hovering || animation_name == 'None') ? (
                        <Image style={{height: 80, width: 80}} src={global.config.static_file_server_path + 'uploads/animation_resources/static-png/' + this.state.activeTab + '-' +animation_name.toLowerCase().split(' ').reduce((final, elem) => final + elem, "")+'.png'}/>
                    ): (
                        <video id={"video-card" + idxx} style={{height: 80, width: 80}} onMouseOver={() => document.getElementById('video-card'+idxx).play()} onMouseOut={() => mouse_out_func(idxx)}>
                            <source style={{height: 80, width: 80}} src={global.config.static_file_server_path + 'uploads/animation_resources/previews-mp4/' + this.state.activeTab + '-' +animation_name.toLowerCase().split(' ').reduce((final, elem) => final + elem, "")+'.mp4'} type="video/mp4"></source>
                        </video>    
                    )
                }
            </div>
        );
    }

    isAnimationActive = (animationName) => {
        if (!this.props.design_selection) return false;

        if (this.state.activeTab === 'page') {
            if(window.design_editor.active_page){
                return window.design_editor.active_page.animation && window.design_editor.active_page.animation === animationName;
            }
        }
        else {
            if (this.props.design_selection.get_parent('grid')) {
                return this.props.design_selection.get_parent('grid').animation && this.props.design_selection.get_parent('grid').animation === animationName;
            } else {
                return this.props.design_selection.animation && this.props.design_selection.animation === animationName;
            }
        }
    };

    generateAnimationCard = (index,animation) => {
        return (<Col
            key={'animation_key' + index}
            style={{padding: '0', marginBottom: '5px'}}
            xs={4}
        >
            <div
                style={{cursor: 'pointer'}}
                onClick={(e) => {
                    this.applyAnimation(animation)
                }}
            >
                <this.animationCard isActive={this.isAnimationActive(animation.displayName)} idxx={index} animation_name={animation.displayName}/>
                <p style={{
                    fontSize: '1.2rem',
                    fontWeight: 400,
                    marginTop: 2,
                    color: 'black',
                    marginLeft: -15
                }}>{animation.displayName}</p>
            </div>
        </Col>)
    };

    // getIsActive = (animationName) => {
    //     if (this.props.design_selection) {
    //         return this.props.design_selection.animation === animationName;
    //     }
    //     else {
    //         return this.state.activeAnimation === animationName;
    //     }
    // }

    isElementSelected = () => {
        if (this.props.design_selection && this.props.design_selection.class_type != 'background') {
            return true;
        } else {
            return false;
        }
    }


    AnimationDurationSlider = () => {
        return (
            <Row style={{marginBottom: 10}}>
                <Col xs={3} className="adjustment-controls-text">
                    Duration
                </Col>
                <Col xs={7}>
                    <input type="range" className="adjustment-slider" name="contrast" min="0.1" max="30"
                           value={this.state.animationDuration}
                           onChange={(e) => this.animationDurationOnChange(e)}/>
                </Col>
                <Col className="filter-adjustment-col" xs={2}>
                    <input type="text" className="adjustment-input-text" name="contrast"
                           onChange={(e) => this.animationDurationOnChange(e)}
                           value={this.state.animationDuration}/>
                </Col>
            </Row>
        );
    }

    AnimationTabView = () => {
        let animationCards = [];
        for (let i = 0; i < window.animationsJSON.length; i++) {
            if (window.animationsJSON[i].pageLevelOnly === true && this.state.activeTab === 'element') continue;
            animationCards.push(this.generateAnimationCard(i, window.animationsJSON[i]))
        }
        return animationCards;
    };

    ElementSelectedHeader = () => (
        <Row>
            <Col xs={6} style={{padding: 0}}>
                <div className={"anim-type-btn" + (this.state.activeTab === 'page' ? " anim-type-btn-selected" : "")} style={{fontSize:'14px'}} onClick={() => {this.setState({'activeTab': 'page'})}}>Page</div>
            </Col>
            <Col xs={6} style={{padding: 0}}>
                <div className={"anim-type-btn" + (this.state.activeTab === 'element' ? " anim-type-btn-selected" : "")} style={{fontSize:'14px'}} onClick={() => this.setState({'activeTab': 'element'})}>Element</div>
            </Col>
        </Row>
    );

    PageSelectedHeader = () => (
        <Row>
            <Col xs={12} style={{padding: 0}}>
                <div className={"anim-type-btn-selected"} style={{fontSize:'14px', 'height': 30, float: 'left'}}>Page</div>
            </Col>
        </Row>
    );

    render() {
        return (
            <div>
                <div style={{paddingRight: 15, paddingBottom: 15}}>
                    {!this.isElementSelected()?<this.PageSelectedHeader/>:<this.ElementSelectedHeader/>}
                </div>
                <div>
                    <this.AnimationTabView/>
                </div>
            </div>
        );
    }
}

export default AnimationsPanel;
